module.exports = __webpack_public_path__ + "img/d4.8f8919d8.png";